import { useEffect, useRef } from 'react'
import { useReactiveVar } from '@apollo/client'
import {
  analyticsClient,
  analyticsIdentityVar,
  identityKey
} from 'shared/analytics'
import { consentVar } from '../store'
import { reportConsent } from '../utils/report-consent'

/**
 * Hands a stored cookie choice to the analytics client (FE-330).
 *
 * The cookie belongs to the browser, the backend keeps the consent per
 * subject: a guest session it has not heard the answer from, or a user who
 * has just signed in, answers on its own row. So the stored choice is
 * reported once for every identity the requests go out as; a choice made on
 * this page load is reported by `grant`.
 */
export const ConsentEffect = () => {
  const identity = useReactiveVar(analyticsIdentityVar)
  const key = identity && identityKey(identity)
  const reportedKey = useRef<string | null>(null)

  useEffect(() => {
    if (consentVar()) analyticsClient.setConsentDecided(true)
  }, [])

  useEffect(() => {
    const choice = consentVar()
    if (!key || !choice || reportedKey.current === key) return

    // NOTE: only the last identity is remembered — coming back to a previous
    // one (sign-out) reports again, as the choice may have changed meanwhile.
    // A choice made before the first identity is still queued in the client,
    // and registering it again replaces that task.
    reportedKey.current = key
    reportConsent(choice)
  }, [key])

  return null
}
